import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 4.403a2.1 2.1 0 0 1 .899-1.114 2.03 2.03 0 0 1 2.617.458c.313.38.485.86.484 1.355 0 1.4-2.058 2.1-2.058 2.1M5.997 10h.006"
    }, null, -1)
  ])))
}
export default { render: render }